const ELLIPSIS = '…';

function shortenToFit(doc, text, maxWidth) {
  let shortened = text.trimEnd();
  while (shortened.length > 0 && doc.getTextWidth(shortened + ELLIPSIS) > maxWidth) {
    shortened = shortened.slice(0, -1).trimEnd();
  }
  return shortened + ELLIPSIS;
}

export function fitTextWithEllipsis(doc, text, maxWidth) {
  if (doc.getTextWidth(text) <= maxWidth) return text;
  return shortenToFit(doc, text, maxWidth);
}

export function clampLinesWithEllipsis(doc, lines, maxLines, maxWidth) {
  if (lines.length <= maxLines) return lines;
  const kept = lines.slice(0, maxLines);
  kept[maxLines - 1] = shortenToFit(doc, kept[maxLines - 1], maxWidth);
  return kept;
}
